import React from 'react';
import { UploadWizardProvider } from '../contexts/UploadWizardContext';
import StepWizardUpload from '../components/upload/StepWizardUpload';

const UploadPage: React.FC = () => {
  return (
    <UploadWizardProvider>
      <StepWizardUpload />
    </UploadWizardProvider>
  );
};

export default UploadPage;